var FuseSharedModule = /** @class */ (function () {
    function FuseSharedModule() {
    }
    return FuseSharedModule;
}());
export { FuseSharedModule };
